import React, { useState, useEffect } from 'react';
import _ from 'underscore';
import { ObservableDataSource } from '../observable/observable-data-source';
import { useReportApiCalls } from '../report-api-calls';


export const globalMenuSavedReportsDataSource = new ObservableDataSource();

const initialize = _.once((reportApiCalls) => {
  globalMenuSavedReportsDataSource.makeCall = reportApiCalls.getSavedReportsForGlobalMenu;
});


// Custom hook for function component
export function useSavedReports() {
  const [data, setData] = useState(undefined);

  initialize(useReportApiCalls());

  useEffect(
    () => {
      let isMounted = true;
      const subscription = globalMenuSavedReportsDataSource.subscribe((newData) => {
        if (isMounted) {
          setData(newData);
        }
      });

      return function cleanup() {
        isMounted = false;
        subscription.unsubscribe();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // only trigger the effect on componentDidMount
  );

  return data;
}

// HoC for class component
export function withSavedReports(Comp) {
  return function CompWrapper(props) {
    const data = useSavedReports();

    return <Comp {...props} savedReports={data} />;
  };
}
